import { Controller } from '@hotwired/stimulus';

// Types the output target's own text back character by character.
//
// The full text is rendered server-side, so without JS — or under
// prefers-reduced-motion — it simply shows as-is. While typing, the element
// carries `is-typing`, then `is-done`: the stylesheet uses those to show the
// caret and to hold back anything marked `auth-typewriter-reveal` until the
// sentence is complete.
export default class extends Controller {
  static targets = ['output'];

  static values = {
    startDelay: { type: Number, default: 1150 },
    spaceDelay: { type: Number, default: 70 },
    minDelay: { type: Number, default: 34 },
    jitter: { type: Number, default: 46 },
  };

  connect() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.text = this.outputTarget.textContent;
    this.index = 0;
    this.outputTarget.textContent = '';
    this.element.classList.add('is-typing');
    this.timeout = setTimeout(() => this.step(), this.startDelayValue);
  }

  disconnect() {
    clearTimeout(this.timeout);
    this.element.classList.remove('is-typing');
  }

  step() {
    this.index += 1;
    this.outputTarget.textContent = this.text.slice(0, this.index);

    if (this.index >= this.text.length) return this.finish();

    const char = this.text[this.index - 1];
    const delay = /\s/.test(char)
      ? this.spaceDelayValue
      : this.minDelayValue + Math.random() * this.jitterValue;

    this.timeout = setTimeout(() => this.step(), delay);
  }

  finish() {
    this.element.classList.remove('is-typing');
    this.element.classList.add('is-done');
  }
}
